import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import type { FieldSource } from '@client/api';

const SOURCE_COLOR: Record<FieldSource, string> = {
  Interpreted: 'bg-white/10 text-white/70',
  Api: 'bg-sky-500/20 text-sky-300',
  ConfirmedAgainstExio: 'bg-teal-500/20 text-teal-300',
  Manual: 'bg-amber-500/20 text-amber-300',
};

export function FieldSourceTag({ source }: { source?: FieldSource }) {
  const { t: tAgreements } = useTranslation('agreements');
  if (!source) return null;

  return (
    <span className={classNames('inline-block rounded-full px-2 py-0.5 text-[10px] font-medium', SOURCE_COLOR[source])}>
      {tAgreements(`agreementImport.review.sourceTag.${source}`)}
    </span>
  );
}
